import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/routes/guards';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const MyDisputesPage = lazy(() => import('./pages/MyDisputes'));
const NewDisputePage = lazy(() => import('./pages/NewDispute'));
const DisputeViewPage = lazy(() => import('./pages/DisputeView'));
const RegularizePage = lazy(() => import('./pages/Regularize'));

/**
 * Questionamentos do paciente (T-16, T-17) e regularização de biometria (F-22).
 * Contrato: o histórico (T-15) abre `/questionamentos/novo?atendimento=<encounterId>`.
 * `/conta/regularizar` não exige cadastro "liberado": a conta bloqueada precisa conseguir chegar aqui.
 */
const routes: RouteObject[] = [
  { path: '/questionamentos', element: <RequireAuth registered><MyDisputesPage /></RequireAuth> },
  { path: '/questionamentos/novo', element: <RequireAuth registered><NewDisputePage /></RequireAuth> },
  { path: '/questionamentos/:id', element: <RequireAuth registered><DisputeViewPage /></RequireAuth> },
  { path: '/conta/regularizar', element: <RequireAuth><RegularizePage /></RequireAuth> },
];
export default routes;
